<div class="box welcome-box" *ngIf="!onboardingComplete()">
    <div class="welcome-header-wrapper" *ngIf="isLife()">
        <!-- welcome text block -->
        <h1 class="welcome-title">{{ "overview.welcome_title" | translate }}</h1>
        <h3 class="welcome-subtitle">{{ "overview.welcome_subtitle" | translate }}</h3>
        <li class="welcome-bullets">{{ "overview.welcome_create_new" | translate }}</li>
        <li class="welcome-bullets">{{ (!noShare() ? "overview.welcome_recieve_payouts" : "overview.welcome_laundry_no_pay") | translate }}</li>
        <p class="pt-2">{{ "overview.welcome_activate_steps" | translate }}</p>
        <!-- divider -->
        <hr class="welcome-divider" />

        <!-- title -->
        <h2 class="get-started">{{ "overview.get_started" | translate }}</h2>
    </div>

    <div class="welcome-header-wrapper" *ngIf="!isLife()">
        <!-- welcome text block -->
        <h1 class="welcome-title">{{ "overview.welcome_almost_there" | translate }}</h1>
        <p class="welcome-bullets">{{ "overview.welcome_users_can_start" | translate }}</p>
        <p class="welcome-bullets">{{ "overview.started_collecting_money" | translate }}</p>

        <!-- divider -->
        <hr class="welcome-divider" />
    </div>

    <div class="welcome-steps">
        <!-- STEP 1 -->
        <div class="step-item">
            <div class="step-item-upper-part">
                <div class="step-progress">
                    <div [className]="hasCompletedAccountInformation() ? 'step-number done' : 'step-number active'">1</div>
                    <div [className]="hasCompletedAccountInformation() ? 'col-12 step-bar done' : 'col-12 step-bar'"></div>
                </div>
                <div class="step-details">
                    <div [className]="'step-title'">
                        <h3>{{ (noShare() ? "overview.account_details" : "overview.account_information") | translate }}</h3>
                        @if (hasCompletedAccountInformation()) {
                            <div>
                                <img src="assets/icons/check-circle.svg" alt="{{ 'overview.check_mark' | translate }}" />
                            </div>
                        }
                    </div>
                    <p class="step-description">
                        {{ (noShare() ? "overview.fill_in_remaining_info" : "overview.which_account_to_send_money") | translate }}
                    </p>
                </div>
            </div>
            <button (click)="onboardingAction('external_account')" [className]="hasCompletedAccountInformation() ? 'step-btn btn btn-primary' : 'step-btn btn btn-secondary'">
                {{ hasCompletedAccountInformation() ? ("overview.change" | translate) : ("overview.begin" | translate) }}
            </button>
        </div>

        @if (shouldShowKYC()) {
            <!-- STEP 2  -->
            <div class="step-item">
                <div class="step-item-upper-part">
                    <div class="step-progress">
                        <div [className]="hasCompletedKYC() ? 'step-number done' : nextStepIsKYC() ? 'step-number' : 'step-number inactive'">2</div>
                        <div *ngIf="isLife() && subCustomerPermissions()?.allow_billing" [className]="hasCompletedKYC() ? 'col-12 step-bar done' : nextStepIsKYC() ? 'col-12 step-bar active' : 'col-12 step-bar'"></div>
                    </div>
                    <div class="step-details">
                        <div [className]="nextStepIsKYC() ? 'step-title' : hasCompletedKYC() ? 'step-title' : 'step-title inactive'">
                            <h3>{{ "overview.stripe_kyc" | translate }}</h3>
                            @if (hasCompletedKYC()) {
                                <div>
                                    <img src="assets/icons/check-circle.svg" alt="{{ 'overview.check_mark' | translate }}" />
                                </div>
                            }
                        </div>
                        <p [className]="nextStepIsKYC() ? 'step-description' : hasCompletedKYC() ? 'step-description' : 'step-description inactive'">
                            {{ "overview.stripe_requires_info" | translate }}
                        </p>
                    </div>
                </div>
                <div class="step-item-lower-part">
                    <button
                        (click)="onboardingAction('capabilities')"
                        [disabled]="
                            showSmallLoadingIndicator || onboardingState().capabilities === 'pending' || (!nextStepIsKYC() && onboardingState().capabilities !== 'active') || !authService.hasLimitedAccess('edit_kyc', authService.getRole())
                        "
                        class="step-btn btn btn-secondary"
                        [class.btn-secondary]="!hasCompletedKYC()"
                        [class.btn-primary]="hasCompletedKYC()"
                        [class.inactive]="showSmallLoadingIndicator || onboardingState().capabilities === 'pending' || (!nextStepIsKYC() && onboardingState().capabilities !== 'active')"
                    >
                        {{
                            showSmallLoadingIndicator
                                ? ""
                                : onboardingState().capabilities === "active"
                                  ? ("overview.change" | translate)
                                  : onboardingState().capabilities === "missing_document"
                                    ? ("overview.provide" | translate)
                                    : onboardingState().capabilities === "pending"
                                      ? ("overview.pending" | translate)
                                      : ("overview.begin" | translate)
                        }}
                        <app-loading-indicator *ngIf="showSmallLoadingIndicator" [size]="'large'" [color]="'white'"></app-loading-indicator>
                    </button>
                    <div class="step-notifications mt-2">
                        <div *ngIf="onboardingState().capabilities === 'missing_document'">
                            <img src="../../../assets/icons/missing.svg" alt="{{ 'overview.missing_details' | translate }}" />
                            <p class="missing">{{ "overview.missing_details" | translate }}</p>
                        </div>
                        <div *ngIf="onboardingState().capabilities === 'pending'">
                            <img src="../../../assets/icons/pending.svg" alt="Pending verification of provided details" />
                            <p>{{ "overview.waiting_verification" | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        }

        @if (shouldShowPlanAndBilling()) {
            <!-- STEP 3 - Not here if subcustomer, who does not pay themselves -->
            <div class="step-item">
                <div class="step-item-upper-part">
                    <div class="step-progress">
                        <div class="step-number" [class.inactive]="!hasCompletedKYC()" [class.done]="hasCompletedPlan()" [class.active]="hasCompletedKYC() && !hasCompletedPlan()">
                            {{ shouldShowKYC() ? "3" : "2" }}
                        </div>
                        <div class="col-12 step-bar" [class.done]="hasCompletedPlan()" [class.active]="hasCompletedKYC()"></div>
                    </div>
                    <div class="step-details">
                        <div class="step-title" [class.inactive]="!hasCompletedKYC()">
                            <h3>{{ "overview.plan" | translate }}</h3>
                            @if (hasCompletedPlan()) {
                                <div>
                                    <img src="assets/icons/check-circle.svg" alt="{{ 'overview.check_mark' | translate }}" />
                                </div>
                            }
                        </div>
                        <p class="step-description" [class.inactive]="!hasCompletedKYC()">
                            {{ "overview.plan_description" | translate }}
                        </p>
                    </div>
                </div>
                <button (click)="onboardingAction('plan')" class="step-btn btn" [class.btn-primary]="hasCompletedPlan()" [disabled]="!hasCompletedKYC()" [class.btn-secondary]="!hasCompletedPlan()" [class.inactive]="!hasCompletedKYC()">
                    {{ hasCompletedPlan() ? ("overview.change" | translate) : ("overview.begin" | translate) }}
                </button>
            </div>
        }

        <!-- STEP 4 -->
        <div class="step-item" *ngIf="!isLife() && !subCustomerPermissions()?.allow_billing"></div>
        @if (shouldShowPlanAndBilling()) {
            <div class="step-item">
                <div class="step-item-upper-part">
                    <div class="step-progress last-item">
                        <div [className]="nextStepIsBilling() ? 'step-number' : 'step-number inactive'">
                            {{ noShare() ? "3" : "4" }}
                        </div>
                        <div class="col-12"></div>
                    </div>
                    <div class="step-details">
                        <div [className]="nextStepIsBilling() ? 'step-title' : 'step-title inactive'">
                            <h3>{{ "misc.billing" | translate }}</h3>
                        </div>
                        <p [className]="nextStepIsBilling() ? 'step-description' : 'step-description inactive'">
                            {{ "overview.activate_airwallet" | translate }}
                        </p>
                    </div>
                </div>
                <!--TODO: Fix boolean for disabled -->
                <button (click)="onboardingAction('billing')" [disabled]="!nextStepIsBilling()" [className]="nextStepIsBilling() ? 'step-btn btn btn-secondary' : 'step-btn btn btn-primary inactive'">
                    {{ "overview.begin" | translate }}
                </button>
            </div>
        }
    </div>
</div>
